<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from '@/components/Page-header';
import appConfig from "../../../../../app.config";


/**
 * Form elements component
 */
export default {
 page: {
    title: "Capacitación del copasst",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "",
      items: [
        {
          text: "Base de conocimiento",
          href: "/forms/general",
        },
        {
          text: "Capacitación del copasst",
          active: true,
        },
      ],
      text: `
          Ad leggings keytar, brunch id art party dolor labore. Pitchfork yr enim lo-fi before they sold out qui. Tumblr farm-to-table bicycle rights whatever. Anim keffiyeh carles cardigan. Velit seitan mcsweeney's photo booth 3 wolf moon irure. Cosby sweater lomo jean shorts, williamsburg hoodie minim qui you probably haven't heard of them et cardigan trust fund culpa biodiesel wes anderson aesthetic. Nihil tattooed accusamus, cred irony biodiesel keffiyeh artisan ullamco consequat.
        `,
      text2: `Labore sit culpa commodo elit adipisicing sit aliquip elit proident voluptate minim mollit nostrud aute reprehenderit do. Mollit excepteur eu Lorem ipsum anim commodo sint labore Lorem in exercitation velit incididunt. Occaecat consectetur nisi in occaecat proident minim enim sunt reprehenderit exercitation cupidatat et do officia. Aliquip consequat ad labore labore mollit ut amet. Sit pariatur tempor proident in veniam culpa aliqua excepteur elit magna fugiat eiusmod amet officia.`,
    };
  },
  methods: {
    /**
     * Scrollspy
     */
    scrollIntoView(evt) {
      evt.preventDefault();
      const href = evt.target.getAttribute("href");
      const el = href ? document.querySelector(href) : null;
      if (el) {
        this.$refs.content.scrollTop = el.offsetTop;
      }
    },
    
  },

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  

   
    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-12">
        <div class="card">
          <div class="card-body"> 
            <div class="row">
              <div class="col-6">
                <h4 class="header-title">Capacitación del copasst</h4>
              </div>

              <div class="col-6 text-right">
                <a href="/forms/general" class="btn btn-secondary m-l-5 ml-1" id="tooltip">
                  <i class="fas fa-arrow-left"></i>
                </a>
                <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
              </div>
            </div>

           

            <br>
            <b-row>
              <b-col cols="4">
                <b-list-group v-b-scrollspy:listgroup-ex>
                 <!-- <b-list-group-item href="#list-item-1"
                    >¿QUÉ ES EL COMITÉ COPPASST?</b-list-group-item
                  >-->
                  <b-list-group-item href="#list-item-1"
                    >¿Que es la capacitación del copasst?</b-list-group-item
                  >
                 
                  <!--<b-list-group-item href="#list-item-3"
                    >¿Cuando se conforma el COPASST?</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-4"
                    >¿Cada cuanto se reúnen los integrantes del COPASST?</b-list-group-item
                  >
                     <b-list-group-item href="#list-item-5"
                    >!.1.2</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-6"
                    >1.1.3</b-list-group-item
                  >-->
                  
                 
                </b-list-group>
              </b-col>

              <b-col cols="8">
                <div
                  id="listgroup-ex"
                  style="position: relative; overflow-y: auto; height: 300px"
                >
                  <!--<h4 id="list-item-1">¿Qué es el comité copasst? </h4>
                  <p>...</p>-->
                  <h4 id="list-item-1">¿Que es la capacitación del copasst?</h4>
                   <p>Para el desarrollo adecuado de las funciones del comité, los integrantes deberán capacitarse como mínimo en los siguientes temas: <br/><br/>

                  -	Roles y responsabilidades del Comité Paritario de Seguridad y Salud en el Trabajo COPASST. <br/>
                  -	Metodología para la identificación de peligros, evaluación y valoración de riesgos. <br/>
                  -	Realización de inspecciones de seguridad. <br/>
                  -	Procedimiento para el reporte e investigación de incidentes, accidentes y enfermedades laborales. <br/><br/>

                  De igual manera, todos los integrantes del comité deberán realizar el curso de las 50 horas del SG SST, con el fin de conocer los elementos del sistema de gestión y dar cumplimiento a la resolución 4927 de 2016. <br/><br/>
                  </p>
                 
                 
                   
                    
                <!--  <h4 id="list-item-3">Cuando se conforma el COPASST:  </h4>
                  <p>La resolución 2013 de 1986 resuelve que todas las empresas e instituciones, públicas o privadas, que tengan a su servicio diez o más trabajadores, están obligadas a conformar un COPASST, cuya organización y funcionamiento estará de acuerdo con la normatividad al respecto. El comité de COPASST tiene vigencia de dos años; si uno de sus miembros se retira no es necesario hacer una nueva convocatoria, el retiro y/o remplazo del delegado quedara registrado en las actas.  </p>
                  <h4 id="list-item-4">Cada cuanto se reúnen los integrantes del COPASST: </h4>
                  <p>Debe reunir por lo menos una vez al mes a los representantes del COPASST en la empresa y durante la jornada laboral, manteniendo un archivo de las actas de reunión. Es un organismo de promoción y vigilancia de las normas y reglamentos de seguridad y salud en el trabajo dentro de la institución.  <br><br><br><br><br><br><br><br><br><br><br><br> </p>
                  <h4  id="list-item-5">Item 5</h4>
                  <p>{{ text }}</p>
                   <h4 id="list-item-6">Item 6</h4>
                  <p>{{ text }}</p> 
                  
                  <h4 hidden id="list-item-5"></h4>
                  <p>{{ text }}</p>
                   <h4 hidden id="list-item-6"></h4>
                  <p>{{ text }}</p>-->
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
